import { useQuery } from '@tanstack/react-query';

import { startChatBot } from '../../services/chatBot';
import useFetchHelpCenter from './useFetchHelpCenter';

export default function useFetchVirtualAssistant(
  {
    action,
    enabled = true,
  }: {
    action?: string;
    enabled?: boolean;
  } = { enabled: true }
) {
  const { data: helpCenter } = useFetchHelpCenter();
  const uuid = helpCenter?.uuid;
  return useQuery({
    queryKey: ['virtualAssistant', uuid, action],
    queryFn: () => startChatBot({ uuid, action }),
    enabled: enabled && !!uuid,
  });
}
